import React, { useRef } from "react";
import { motion } from "framer-motion";
import { ReactComponent as SearchIcon } from "../../assets/images/searchBarIMG.svg";
import { ReactComponent as SearchIconActive } from "../../assets/images/icons/searchIconDark.svg";
import useClickOutside from "../../hooks/Screen/useClickOutside";
import { ReactComponent as CrossIcon } from "../../assets/images/icons/CrossSeachIcon.svg";

const MotionSearchBox = ({
  isSearchActive = false,
  setIsSearchActive = () => {},
  searchText = "",
  setSearchText = () => {},
  placeholder = "Search...",
  ClassName = {},
  expanded = false,
  outsideClickEffect = true,
}) => {
  if (expanded) {
    setIsSearchActive(true);
  }

  const handleSearchButtonClick = () => {
    setIsSearchActive((prev) => !prev);
    setSearchText("");
  };

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const inputRef = useClickOutside(() => {
    if (!outsideClickEffect) {
      return;
    }
    if (isSearchActive && !expanded) {
      setIsSearchActive(false);
      setSearchText("");
    }
  });

  return (
    <div className={`relative flex items-center w-fit w-full `} ref={inputRef}>
      {/* Search Input (Expanding Left) */}
      <motion.input
        className={`h-[28px] w-full ${isSearchActive ? "pl-8" : "pl-4"} pr-2 border border-primary-70 rounded-[5px] focus:outline-none focus:ring-0 focus:border-primary ${ClassName}`}
        type="text"
        placeholder={placeholder}
        value={searchText}
        initial={{ width: 0, opacity: 0 }}
        animate={{ width: isSearchActive ? (expanded ? "100%" : "15rem") : "0", opacity: isSearchActive ? 1 : 0 }}
        transition={{ duration: 0.3 }}
        style={{ overflow: "hidden" }}
        onChange={handleSearchChange}
      />

      {/* Search Button */}
      <button className="absolute rounded-full mr-2 p-2 text-primary" onClick={handleSearchButtonClick}>
        {isSearchActive ? (
          <SearchIconActive className="hover:fill-current" />
        ) : (
          <SearchIcon className="hover:fill-current fill-[#8E8E8E]" />
        )}
      </button>

      {/* cross button */}
      {(isSearchActive && !expanded) ||
        (expanded && Boolean(searchText) && (
          <button
            onClick={() => {
              setSearchText("");
              setIsSearchActive(false);
            }}
            className="absolute right-2 top-1/2 transform -translate-y-1/2"
          >
            <CrossIcon />
          </button>
        ))}
    </div>
  );
};

export default MotionSearchBox;
